/* src/app/modules/invoice/preinvoice/barcode-dialog.component.css */
.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
}
img {
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;
}
/*# sourceMappingURL=barcode-dialog.component.css.map */
